module.exports = __webpack_public_path__ + "static/media/puzzle0301.0f2e8e45.jpg";